<!--
  If there's not enough space in the first row, create a separate label row. We mark this row as
  aria-hidden because we don't want it to be read out as one of the weeks in the month.
-->
<tr *ngIf="_firstRowOffset < labelMinRequiredCells" aria-hidden="true">
  <td class="mtx-calendar-body-label" [attr.colspan]="numCols">{{ label }}</td>
</tr>

<!-- Create the first row separately so we can include a special spacer cell. -->
<tr *ngFor="let row of rows; let rowIndex = index" role="row">
  <!--
    We mark this cell as aria-hidden so it doesn't get read out as one of the days in the week.
  -->
  <td *ngIf="rowIndex === 0 && _firstRowOffset"
      class="mtx-calendar-body-label" [attr.colspan]="_firstRowOffset" aria-hidden="true">
    {{ _firstRowOffset >= labelMinRequiredCells ? label : '' }}
  </td>
  <td *ngFor="let item of row; let colIndex = index"
      role="gridcell"
      class="mtx-calendar-body-cell"
      [class.mtx-calendar-body-active]="_isActiveCell(rowIndex, colIndex)"
      [class.mtx-calendar-body-disabled]="!item.enabled"
      [tabindex]="_isActiveCell(rowIndex, colIndex) ? 0 : -1"
      [attr.data-mat-row]="rowIndex"
      [attr.data-mat-col]="colIndex"
      [attr.aria-label]="item.ariaLabel"
      [attr.aria-disabled]="!item.enabled || null"
      (click)="_cellClicked(item)">
    <div class="mtx-calendar-body-cell-content"
         [class.mtx-calendar-body-selected]="selectedValue === item.value"
         [class.mtx-calendar-body-today]="todayValue === item.value"
         [attr.aria-selected]="selectedValue === item.value">
      {{ item.displayValue }}
    </div>
  </td>
</tr>
